export const buttonColorOptions: Array<'primary' | 'secondary' | 'success' | 'error' | 'info' | 'warning'> = [
  'primary',
  'secondary',
  'error',
  'warning',
  'info',
  'success',
]
